import styled, {keyframes} from "styled-components";
import {media, tokens} from "../../../theme";
import {Message} from "../MessagesList/MessagesList.styled";

export const LoadingDots = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    height: 20px;
    margin-bottom: 8px;
    width: 100%;
`;

const dotFlashing = keyframes`
    0% {
        background-color: #989898;
    }
    50%, 100% {
        background-color: rgba(122, 122, 122, 0.3);
    }
`;

export const Dot = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.palette.primary.main};
    animation: ${dotFlashing} 1.5s infinite linear;

    &:nth-child(1) {
        animation-delay: 0s;
    }

    &:nth-child(2) {
        animation-delay: 0.3s;
    }

    &:nth-child(3) {
        animation-delay: 0.6s;
    }
`;

interface MessageSystemProps {
    $hasAttachment?: boolean;
}

export const MessageSystem = styled(Message)<MessageSystemProps>`
    flex-direction: column;
    align-items: flex-start;
    background: transparent;
    border-radius: ${tokens.radius.lg};
    padding: 12px;
    margin-bottom: 0 !important;
    
    ${({ $hasAttachment: hasAttachment }) =>
    hasAttachment &&
    `
        border-bottom-left-radius: 0;
        border-bottom-right-radius: ${tokens.radius.lg};
    `}

    ${media.sm} {
        padding: 14px;
    }

    ${media.md} {
        padding: 16px;
    }
`;


export const MessageSystemText = styled.div`
    font-weight: ${tokens.fontWeight.normal};
    font-size: ${tokens.fontSize.sm};
    word-break: break-word;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    gap: 8px;
    width: 100%;
    position: relative;
    color: ${({ theme }) => theme.palette.message.assistantText};
    background-color: transparent;

    ${media.smPlus} {
        font-size: ${tokens.fontSize.base};
    }
    
    pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-x: auto;
    }

    pre code {
        display: block;
        max-width: 100%;
        box-sizing: border-box;
        white-space: inherit;
    }
`;

export const ErrorMessageSystemText = styled(MessageSystemText)`
    color: ${({ theme }) => theme.palette.error.main};
    font-weight: ${tokens.fontWeight.semibold};;
`;
